import { computed } from "@vue/composition-api";
import router from '@/router'

import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
// import inventory from "@/navigation/inventory";
// import privilege from "@/navigation/privileges";
// import report from "@/navigation/report";
// import banner from "@/navigation/banner";
// import tags from "@/navigation/tags";
// import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
// import article from "@/navigation/article";
// import survey from "@/navigation/survey";

//MBK Custom mudule
import CollectPointByAdmin from "@/constants/navigation/BOYNYKJMS2EH/menu/collect-point-by-admin";
import collectPointByCounter from "@/constants/navigation/BOYNYKJMS2EH/menu/collect-point-by-counter";
import customerManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/customer-management";
import merchantManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/merchant-management";
import pointManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/point-management";
import adjustPoint from "@/constants/navigation/BOYNYKJMS2EH/menu/adjust-point";
import mission from "@/constants/navigation/BOYNYKJMS2EH/menu/mission";
import userManagement from "@/constants/navigation/BOYNYKJMS2EH/menu/user-management";
import article from "@/constants/navigation/BOYNYKJMS2EH/menu/article";
import privilege from "@/constants/navigation/BOYNYKJMS2EH/menu/privilege"; // dev
import report from "@/constants/navigation/BOYNYKJMS2EH/menu/report";
import virtualCard from "@/constants/navigation/BOYNYKJMS2EH/menu/virtual-card";
import virtualCardForSBU from "@/constants/navigation/BOYNYKJMS2EH/menu/virtual-card-for-sbu";
import eStamp from "@/constants/navigation/BOYNYKJMS2EH/menu/e-stamp";
import adjustEStamp from "@/constants/navigation/BOYNYKJMS2EH/menu/adjust-e-stamp";
import banner from "@/constants/navigation/BOYNYKJMS2EH/menu/banner";
import survey from "@/constants/navigation/BOYNYKJMS2EH/menu/survey-quiz";
import fulfillment from "@/constants/navigation/BOYNYKJMS2EH/menu/fulfillment";
import tag from "@/constants/navigation/BOYNYKJMS2EH/menu/tag";
import inventory from "@/constants/navigation/BOYNYKJMS2EH/menu/inventory";
import reconcilePayment from "@/constants/navigation/BOYNYKJMS2EH/menu/reconcile-payment";

import store from "@/store";
import { apiEndpoint } from "@/configs/api/api-configs";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function usePermissionByAccount() {
  const { decodeToken } = useDecodeToken();
  const { openErrorModal, openDefaultErrorModal } = useValidationModal();

  const verticalNavMenu = {
    privileges: [...privilege], // dev
    privilege: [...privilege], // prod
    tags: [...tag], 
    customreport: [...report], // dev
    report: [...report], // prod
    customermanagement: [...customerManagement],
    merchantmanagement: [...merchantManagement],
    pointmanagement: [...pointManagement],
    adjustpoint: [...adjustPoint],
    article: [...article],
    collectpointbyadmin: [...CollectPointByAdmin],
    collectpointbycounter: [...collectPointByCounter],
    mission: [...mission],
    usermanagement: [...userManagement],
    virtualcard: [...virtualCard],
    virtualcardforsbus: [...virtualCardForSBU],
    surveyandquiz: [...survey],
    fulfillment: [...fulfillment],
    banner: [...banner],
    inventory: [...inventory],
    estamp: [...eStamp],  
    adjustestamp: [...adjustEStamp],  
    reconcilepayment: [...reconcilePayment],
  }
  
  const getMenuListMBK = async () => {
    return await store
      .dispatch("api/apiRequest", {
        api: apiEndpoint.bcrm_platform + "/menu/List_MBK",
        method: "GET",
        payload: {
          Brand_Ref: decodeToken().brand_ref,
        },
      })
      .then(res => {
        localStorage.setItem('list_BOYNYKJMS2EH', JSON.stringify(res?.data??[]))
      })
      .catch((error) => {
        router.push({ path: '/error-404' })
        openDefaultErrorModal(error);
      })
      .finally(() => {});
  }

  const clearMenuListMBK = () => {
    localStorage.removeItem("list_BOYNYKJMS2EH")
    localStorage.removeItem("listActive_BOYNYKJMS2EH")
    localStorage.removeItem("permission_access")
  }

  const getNavigationList = computed(() => {
    return (localStorage.getItem("list_BOYNYKJMS2EH")?JSON.parse(localStorage.getItem("list_BOYNYKJMS2EH")):[])?.map(o => {
      if(o?.view) {
        return verticalNavMenu[o?.module_name?.replace(/[' ']/g, '')?.replace(/[-]/g, '').toLowerCase()]
      }
    }).filter(o => o).flatMap(o => o).sort((a, b) => a?.title.localeCompare(b?.title));
  })
  const updateActiveModule = (moduletitle) => {
    localStorage.setItem('listActive_BOYNYKJMS2EH', moduletitle)
  }
  // เป็นฟังก์ชัน ไม่ใช่ computed ที่ถูกอ่านค่าตอน return
  // เดิมส่ง .value ออกไป ผู้เรียกจึงได้ค่า ณ ตอนที่ setup() ทำงานครั้งเดียว
  // ทำให้หลังคลิกเมนู ต้อง reload หน้าก่อน permission_access ถึงจะถูกต้อง
  const getActiveModule = () => localStorage.getItem('listActive_BOYNYKJMS2EH')
  const getPermissionModuleActive = (moduleName) => {
    const response = (localStorage.getItem("list_BOYNYKJMS2EH")?JSON.parse(localStorage.getItem("list_BOYNYKJMS2EH")):[])?.filter(o => o.module_name?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase() === (moduleName?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase()) || moduleName?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase() === (o.module_name?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase()))
    return response  
  }
  const getPermissionModule = (moduleName) => {
    return (localStorage.getItem("list_BOYNYKJMS2EH")?JSON.parse(localStorage.getItem("list_BOYNYKJMS2EH")):[])?.find(o => o.module_name?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase().includes(moduleName?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase()) || moduleName?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase().includes(o.module_name?.replace(/[' ']/g, '').replace(/[-]/g, '').toLowerCase()))??{adjust: false, view: false}
  }
  const getModuleIcon = (module_name) => {
    return `${module_name?.replace(/[' ']/g, '')?.replace(/[-]/g, '')??"Custom"}SVG`
  }
  return {
    getMenuListMBK,
    clearMenuListMBK,
    getNavigationList: getNavigationList.value,
    getPermissionModule,
    getPermissionModuleActive,
    updateActiveModule,
    getActiveModule,
    getModuleIcon
  };
}